import * as React from 'react'
import * as domain from '@packages/domain'
import { E, flow, pipe, RA, TE } from '@packages/prelude'
import { ADTType, makeADT, ofType } from '@morphic-ts/adt'
import { formatValidationErrors } from 'io-ts-reporters'
import { StarGreeting } from '../components'

interface Recording {
  type: 'Recording'
  id: number
  audio: Blob
}

interface Name {
  type: 'Name'
  id: number
  name: string
}

interface StarGreeting {
  type: 'StarGreeting'
  id: number
  greeting: string
}

export const PreviewData = makeADT('type')({
  Recording: ofType<Recording>(),
  Name: ofType<Name>(),
  StarGreeting: ofType<StarGreeting>()
})

export type PreviewData = ADTType<typeof PreviewData>

export const useIndiAudioPreview = (productId: number, config: domain.Api.Config.Type) => {
  return {
    generatePreview: React.useMemo(
      () => (previewData: ReadonlyArray<PreviewData>) =>
        pipe(
          TE.of(new FormData()),
          TE.map(formData => {
            pipe(
              previewData,
              RA.map(
                PreviewData.matchStrict({
                  Recording: ({ audio, id }) => {
                    formData.append(String(id), audio, 'rec.webm')
                  },
                  Name: ({ name, id }) => {
                    formData.append(String(id), name)
                  },
                  StarGreeting: ({ greeting, id }) => {
                    formData.append(String(id), greeting)
                  }
                })
              )
            )

            return formData
          }),
          TE.chain(
            TE.tryCatchK(
              formData =>
                fetch(`${config.wpApiBase}/indiaudio/preview/${productId}`, {
                  method: 'POST',
                  body: formData
                }).then(response => response.json()),
              E.toError
            )
          ),
          TE.chainEitherKW(
            flow(
              domain.Api.IAGenPreviewResponse.Type.decode,
              E.mapLeft(flow(formatValidationErrors, RA.join(';'))),
              E.mapLeft(err => new Error(err))
            )
          )
        ),
      [productId, config]
    )
  }
}
